import { pages } from '@app/util/links'
import {
  initiativeCreationStepDescriptionTranslation,
  initiativeCreationStepTitleTranslation,
  initiativePhaseDescriptionTranslation,
  initiativePhaseNameTranslation,
  initiativeUserRoleTranslation,
  notificationFrequencyTranslation,
  phaseTranslations,
  plotApplicationStatusesTranslations,
  humberOfHomesTranslation,
  ownershipModeTranslation,
  rentSegmentTranslation,
} from '@i18n/languages/nl.enumTranslations'

const shared = {
  ambassador: 'Ambassadeur',
  ambassadors: 'Ambassadeurs',
  experts: 'Experts',
  crowdBuilding: 'CrowdBuilding',
  contactUsLink: 'Contact',
  knowledgeHub: 'Kennishub',
  storiesLink: 'Verhalen',
  initiative: {
    singular: 'Initiatief',
    plural: 'Initiatieven',
  },
  location: {
    singular: 'Locatie',
    plural: 'Locaties',
  },
  housingForms: 'Woonvormen',
  sendMessage: 'Stuur bericht',
  back: 'Terug',
  yes: 'Ja',
  no: 'Nee',
  noPreference: 'Geen voorkeur',
  external: 'Extern',
  messages: 'Berichten',
  purchaseBudget: 'Koopbudget',
  rentalBudget: 'Huurbudget',
  loading: 'Laden...',
  unknownLocation: 'Onbekende locatie',
  unknown: 'Onbekend',
  notSpecified: 'Niet gespecificeerd', // Comment LF: need more context
  members: 'Deelnemers',
  followers: 'Volgers',
  follow: 'Volgen',
  following: 'Volgend',
  admins: 'Beheerders',
  followTooltip: 'Volg voor updates',
  signUp: 'Aanmelden',
  lockedPageFollowed: 'Je volgt deze pagina',
  lockedPageFollowedText:
    'Zodra deze pagina live gaat, krijg jij als een van de eerste een melding.',
  attention: 'Let op',
  more: 'Meer',
  cancel: 'Annuleren',
}

export default {
  app: {
    badges: {
      initiativeTaker: 'Initiatiefnemer',
    },
    knowledgeHubTab: {
      title: shared.knowledgeHub,
      noModules: 'Geen kennismodules gekoppeld.',
    },
    blogPage: {
      title: 'Actueel',
      description:
        'Verhalen, nieuws en updates over collectief bouwen en samenwonen op CrowdBuilding.',
      loading: shared.loading,
      tabs: {
        stories: 'Verhalen',
        news: 'Nieuws',
        blog: 'Blog',
        agenda: 'Agenda',
      },
      noContent: 'Geen inhoud gevonden',
    },
    eventsPage: {
      title: 'Agenda',
      description:
        'Evenementen, bijeenkomsten en workshops over collectief bouwen en samenwonen.',
      noAttendees: 'Geen deelnemers voor nu',
      pastEvents: 'Afgelopen evenementen',
    },
    businessProfilePage: {
      address: 'Adres',
      email: 'E-mail',
      phone: 'Telefoonnummer',
      website: 'Website',
      specializations: 'Gespecialiseerd in',
    },
    common: {
      yes: 'Ja',
      no: 'Nee',
      other: 'Andere',
      cancel: 'Terug',
      save: 'Opslaan',
      back: shared.back,
      continue: 'Bevestigen',
      attention: shared.attention,
      note: 'Let op:',
      seeMore: 'Bekijk alles',
      hide: 'Verbergen',
      readMore: 'Lees meer',
      readLess: 'Lees minder',
      initiative: shared.initiative,
      unknownLocation: shared.unknownLocation,
      share: 'Delen',
      banner: 'Banner',
      follow: shared.follow,
      followTooltip: shared.followTooltip,
      unfollow: 'Niet meer volgen',
      following: shared.following,
      contact: 'Contact',
      followers: 'Volgers',
      followersAmount: '{0} volgers',
      notSpecified: shared.notSpecified,
      initiativePhases: phaseTranslations,
      initiativeStatus: {
        searchingForMembers: 'Op zoek naar leden',
        notSearchingForMembers: 'Zoekt nu geen leden',
      },
      plotApplicationStatus: plotApplicationStatusesTranslations,
      initiativeUserRole: initiativeUserRoleTranslation,
      loading: shared.loading,
      more: shared.more,
      less: 'Minder',
      location: 'Plaats',
      locationNotFoundMessage: 'Plaats niet gevonden',
      region: 'Provincie',
      regionNotFoundMessage: 'Provincie niet gevonden',
      toastSuccess: 'Succes!',
      toastFailure: 'Er is iets misgegaan',
      genericToastFailureMessage:
        'Probeer het nog eens. Neem contact op met CrowdBuilding als het probleem zich blijft voordoen.',
      sendMessage: shared.sendMessage,
      unknown: shared.unknown,
      noItems: 'Geen items gevonden',
      filtersTooltip: 'Filters',
      signUp: shared.signUp,
    },
    auth: {
      logIn: 'Inloggen',
      signUp: shared.signUp,
      logInTitle: 'Log in op je CrowdBuilding-account',
      signUpTitle: 'Van dromen naar wonen.',
      signUpSubtitle: 'Meld je gratis aan.',
      shareMoreTitle: 'Deel iets over jezelf.',
      shareMoreSubtitle:
        'Zo vind je sneller mensen en initiatieven die bij jou passen.',
      email: 'E-mail',
      emailPlaceholder: 'Voer je e-mailadres in...',
      emailSubtitle: 'Op dit e-mailadres ontvang je een inlogcode.',
      privacySubtitle: 'Door je aan te melden ga je akkoord met onze',
      privacySubtitleAnd: 'en',
      privacyStatementLink: 'privacyverklaring',
      termsAndConditionsLink: 'algemene voorwaarden',
      privacyStatementTitle: 'CrowdBuilding Privacyverklaring',
      termsAndConditionsTitle: 'Algemene Voorwaarden',
      firstName: 'Voornaam',
      firstNamePlaceholder: 'Voornaam',
      lastName: 'Achternaam',
      lastNamePlaceholder: 'Achternaam',
      placeOfResidence: 'Woonplaats',
      ageCategory: 'Leeftijdscategorie',
      ageCategoryPlaceholder: 'Selecteer...',
      searchRegion: 'Zoekregio',
      searchRegionPlaceholder: 'Waar zou je willen wonen?',
      continueWithGoogle: 'Ga verder met Google',
      continueWithApple: 'Ga verder met Apple',
      loginButton: 'Inloggen',
      signUpButton: 'Maak een account',
      verificationCodeBanner:
        'Je hebt een bevestigingscode ontvangen per e-mail. Kijk ook in je ongewenste e-mail.',
      verificationLabel: 'Bevestigingscode',
      emailInvalidMessage: 'Controleer uw e-mail en probeer het opnieuw.', //Comment LF: need more context
      emailIssueNoUserMessage: 'Gebruiker met dit e-mailadres bestaat niet',
      emailIssueUserExistsMessage:
        'De gebruiker met dit e-mailadres bestaat al',
      emailIssueOtherMessage: 'Er is iets misgegaan',
      otcIssueMessage:
        'Onjuiste 2FA-code. Probeer het opnieuw of vraag een nieuwe code aan.',
      nameInvalidMessage: 'Mag niet leeg zijn.',
      otherIssueMessage: 'Er is iets misgegaan. Probeer het opnieuw.',
      sendCodeAgain: 'Code opnieuw versturen',
      sendCodeAgainCountdown: 'Code opnieuw versturen in {seconds}s',
      alreadyLoggedIn: 'Je bent al ingelogd.',
    },
    discoveryPage: {
      initiatives: shared.initiative.plural,
      plots: shared.location.plural,
      regions: "Regio's",
      housingForms: shared.housingForms,
      searchResults: {
        singular: 'resultaat',
        plural: 'resultaten',
      },
      searchPlaceholder: {
        mobile: 'Zoek',
        initiatives: 'Zoek op trefwoord, gemeente of provincie',
        plots: 'Zoek op trefwoord, gemeente of provincie',
        regions: 'Zoek op trefwoord, gemeente of provincie',
        housingForms: 'Zoek op trefwoord',
      },
      searchSuggestions: {
        locality: 'Plaats in {0}',
        municipality: 'Gemeente in {0}',
        region: 'Provincie in {0}',
      },
      filterDrawer: {
        title: 'Filters',
        phase: 'Fase',
        applicationStatus: 'Fase',
        lookingForMembers: 'Op zoek naar leden',
        developmentForm: 'Ontwikkelvorm',
        province: 'Provincie',
        applicationType: 'Type inschrijving',
        apply: 'Toepassen',
        back: shared.back,
        initiativePhases: phaseTranslations,
        plotApplicationStatuses: plotApplicationStatusesTranslations,
        yes: shared.yes,
        no: shared.no,
        noPreference: shared.noPreference,
        external: shared.external,
        crowdBuilding: shared.crowdBuilding,
        crowdBuildingTooltip: 'Inschrijven op tenders via CrowdBuilding.',
        externalTooltip: 'Inschrijven via externe website',
      },
      tabs: {
        initiatives: {
          title: 'Ontdek initiatieven',
          subTitle:
            'Vind initiatieven die bij jouw woondroom passen en kom met elkaar in contact.',
          spotlight: {
            title: 'Uitgelichte initiatieven',
            subTitle:
              'Deze uitgelichte initiatieven zijn op zoek naar nieuwe leden.',
          },
          emptyTitle: 'Geen initiatieven gevonden',
          emptyDescription:
            'Pas je zoekterm of filters aan om te vinden wat je zoekt.',
        },
        plots: {
          title: 'Ontdek locaties',
          subTitle:
            'Vind kavels, gebouwen of grond om jouw woondroom te realiseren.',
          mapTitle: {
            singular: 'Er is {0} initiatief',
            plural: 'Er zijn {0} initiatieven',
          },
          emptyTitle: 'Geen locaties gevonden',
          emptyDescription:
            'Pas je zoekterm of filters aan om te vinden wat je zoekt.',
          spotlight: {
            title: 'Uitgelichte locaties',
            subTitle: 'Bekijk de uitgelichte kavels en gebouwen.',
          },
        },
        regions: {
          provinceTitle: "Ontdek regio's",
          provinceSubTitle:
            'Ontdek wat er in jouw zoekregio gebeurt rondom gemeenschappelijk bouwen en wonen.',
          municipalitesTitle: 'Alle gemeenten',
          municipalitesSubtitle:
            'Ontdek wat er gaande is op het gebied van samen bouwen en wonen.',
          featuredMunicipalitesTitle: 'Uitgelicht',
          featuredMunicipalitesSubtitle:
            'Bekijk het laatste nieuws, beleid, initiatieven en locaties in deze populaire gemeenten.',
          emptyTitle: 'Geen gemeenten gevonden',
          emptyDescription:
            'Pas je zoekterm of filters aan om te vinden wat je zoekt.',
        },
        housingForms: {
          title: 'Ontdek woonvormen',
          subtitle:
            "Ontdek verschillende thema's binnen samen bouwen en wonen.",
          emptyTitle: 'Geen woonvormen gevonden',
          emptyDescription: 'Pas je zoekterm aan om te vinden wat je zoekt.',
        },
      },
    },
    housingFormPage: {
      loading: shared.loading,
      follow: shared.follow,
      following: shared.following,
      ambassador: shared.ambassador,
      ambassadorCard: {
        title: shared.ambassador,
      },
      popularHousingFormsCard: {
        title: 'Populaire woonvormen',
      },
      noExpertsTitle: 'Nog geen experts',
      noInitiativesTitle: 'Wees de eerste',
      noInitiativesCta: 'Start initiatief',
      noInitiativesDescription: 'Wees de eerste, maak je initiatief aan',
      noLocationsTitle: 'Nog geen matchende locaties',
      noLocationsDescription: 'Meld zelf een gebouw of kavel aan.',
      tabs: {
        overview: 'Overzicht',
        discussion: 'Prikbord',
        initiatives: 'Initiatieven',
        plots: 'Locaties',
        experts: shared.experts,
        popularHousingForms: 'Populaire woonvormen',
        knowledgeHub: shared.knowledgeHub,
        current: 'Actueel',
      },
      pageTabTitle: {
        overview: '',
        discussion: '{0} discussie',
        initiatives: '{0} initiatieven',
        plots: '{0} locaties',
        knowledgeHub: '{0} kennishub',
        current: '{0} actueel',
        popularHousingForms: 'Populaire woonvormen',
        experts: '{0} experts',
      },
    },
    topicCommunityPage: {
      loading: shared.loading,
      follow: shared.follow,
      following: shared.following,
      managedBy: 'Beheerd door',
      featuredInitiatives: 'Uitgelichte initiatieven',
      noKnowledgeHubModules: 'Er zijn nog geen kennismodules beschikbaar.',
      relatedHousingFormsCard: {
        title: 'Woonvormen',
      },
      networksCard: {
        title: 'Netwerken',
      },
      tabs: {
        overview: 'Overzicht',
        discussion: 'Prikbord',
        initiatives: 'Initiatieven',
        knowledgeHub: shared.knowledgeHub,
        contactInfo: 'Contact',
        events: 'Agenda',
      },
      noContact: 'Geen contactinformatie beschikbaar.',
      noEvents: 'Geen evenementen gekoppeld.',
      municipality: 'Gemeente',
      knowledgeBank: 'Kennisbank',
    },
    legalPage: {
      title: 'Juridische documenten',
      description: 'Algemene voorwaarden en privacybeleid.',
      termsAndConditionsDownloadTitle: 'Algemene Voorwaarden',
      privacyPolicyDownloadTitle: 'Privacy Verklaring',
      cookiePolicyDownloadTitle: 'Cookiebeleid',
      downloadButtonLabel: 'PDF Downloaden',
    },
    aboutUsPage: {
      title: 'Een eerlijk en duurzaam woningbouw- systeem',
      description:
        'Hoe wij bijdragen aan een eerlijke en duurzame woningmarkt.',
      hero2ImageAlt: 'Foto van drijvende huizen',
    },
    contactPage: {
      title: shared.contactUsLink,
      description:
        'Heb je een vraag? Neem contact op met support, ons pers- en mediateam, of bezoek ons kantoor in Amsterdam.',
    },
    stewardOwnershipPage: {
      title: 'CrowdBuilding is steward-owned',
      description:
        'Onze missie staat centraal en is juridisch vastgelegd. Steward-ownership houdt winst in dienst van maatschappelijke impact.',
    },
    forExpertsPage: {
      title: 'Voor experts',
      description:
        'CrowdBuilding is op zoek naar professionele partners in heel Nederland die onze visie op collectief wonen delen.',
    },
    rabobankLandingPage: {
      title: 'CPO-desk in jouw regio',
      description:
        'Van plan om samen met een groep een CPO-project te starten? Dan helpt Rabobank je graag verder.',
    },
    regionCard: {
      initiatives: {
        singular: 'initiatief',
        plural: 'initiatieven',
      },
      subsidies: {
        singular: 'subsidie',
        plural: 'subsidies',
      },
      plots: {
        singular: 'kavel',
        plural: 'kavels',
      },
    },
    serviceProviderPage: {
      overview: 'Overzicht',
      events: 'Agenda',
      initiatives: 'Initiatieven',
      knowledgeHub: shared.knowledgeHub,
      current: 'Actueel',
      ourInitiatives: 'Onze initiatieven',
      ourInitiativesDescription:
        'Sluit je aan bij een van onze collectieve initiatieven.',
      developmentArea: 'Ontwikkelgebied',
      concepts: 'Concepten',
      ourConcepts: 'Onze concepten',
      address: 'Adres',
      email: 'E-mail',
      phone: 'Telefoonnummer',
      website: 'Website',
      specializations: 'Specialisme',
      activeRegions: 'Werkgebied',
      loading: shared.loading,
      notFound: 'Expert niet gevonden',
      noInitiativesTitle: 'Wees de eerste',
      noInitiativesCta: 'Start initiatief',
      noInitiativesDescription: 'Wees de eerste, maak je initiatief aan',
    },
    serviceProviderConceptPage: {
      tabs: {
        overview: 'Overzicht',
        initiatives: shared.initiative.plural,
        discussion: 'Prikbord',
      },
      offeredBy: 'Aangeboden door',
      members: shared.members,
      loading: shared.loading,
      initiatives: shared.initiative.plural,
      initiativesDescription:
        'Doe mee met een van de gezamenlijke initiatieven.',
    },
    discoverServiceProviders: {
      title: 'Experts',
      description:
        'Van architecten tot procesbegeleiders en van financieel adviseurs tot lokale steunpunten: vind de juiste hulp voor iedere fase van jouw zelfbouwinitiatief.',
      filters: 'Filters',
      removeFilters: 'Verwijder Filters',
      searchPlaceholder: 'Zoek op experts',
      emptyTitle: 'Geen experts gevonden',
      emptyDescription:
        'Pas je zoekterm of filters aan om te vinden wat je zoekt.',
      categories: {
        processSupervision: 'Procesbegeleiding',
        architecture: 'Architectuur',
        advice: 'Advies',
        financing: 'Financiering',
        development: 'Ontwikkeling',
        construction: 'Bouw',
        networks: 'Netwerken',
        supportPoint: 'Steunpunt',
      },
      filtersModal: {
        title: 'Filters',
        specialism: 'Specialisme',
        type: 'Type',
        operatingArea: 'Werkgebied',
        apply: 'Toepassen',
      },
    },
    footer: {
      slogan: 'De ultieme woonplek bouw\nje samen',
      info: 'Info',
      services: 'Aanbod',
      joinIn: 'Doe mee',
      sections: {
        info: {
          howDoesItWork: 'Hoe werkt het?',
          contactUsLink: shared.contactUsLink,
          knowledgeHub: shared.knowledgeHub,
          storiesLink: shared.storiesLink,
          blogAndNewsLink: 'Actueel',
          events: 'Agenda',
          termsAndConditions: 'Algemene voorwaarden',
          privacy: 'Privacyverklaring',
        },
        services: {
          initiatives: 'Initiatieven',
          plots: 'Locaties',
          housingForms: shared.housingForms,
          experts: 'Experts',
          cpoDesks: 'CPO-desk in jouw regio',
        },
        joinIn: {
          joinGroup: 'Meld een initiatief aan',
          applyForPlot: 'Meld een locatie aan',
          forExperts: 'Voor experts',
          forMunicipalities: 'Voor gemeenten',
          joinUsLink: 'Werken bij CrowdBuilding',
        },
      },
    },
    knowledgeHubPage: {
      title: 'Kennishub',
      description:
        'Hier vind je alle informatie die je nodig hebt om jouw woonwens te realiseren.',
      loading: 'Laden...',
      menu: 'Kennishub Menu',
      searchPlaceholder: 'Zoek',
      noResults: 'Geen resultaten gevonden',
      noArticlesTitle: 'Geen artikelen gevonden',
      noArticlesDescription:
        'Pas je filters of zoekterm aan en probeer opnieuw.',
      back: shared.back,
    },
    elearningPage: {
      sidebarTitle: 'Inhoud',
      searchPlaceholder: 'Zoek',
      title: 'Leeromgeving',
      description:
        'Modules en opdrachten om samen met je groep stap voor stap jullie wooninitiatief te ontwikkelen.',
      loading: 'Laden...',
      menu: 'Leeromgeving Menu',
      previous: 'Vorige',
      next: 'Volgende',
      selectItem: 'Selecteer een item uit het menu',
      viewSlides: 'Bekijk de slides',
      viewSlidesDesc:
        'Wil je de presentatie nog eens op eigen tempo bekijken? Bekijk hieronder de slideshow. Je kunt de presentatie ook downloaden en uitprinten.',
      assignments: 'Opdrachten bij de modules',
      assignmentsDesc1:
        'Aan het eind van elke module kun je een opdrachtformulier downloaden. Daarop staan vragen voor jou en een opdracht die je samen met je groep doet.',
      assignmentsDesc2:
        'De vragen die je zelf invult zijn bedoeld om jouw eigen gedachten op een rijtje te zetten. Daarna kan je goed voorbereid met andere groepsleden in gesprek over jouw visie en jullie woondroom. Zo kom je elke module een stapje dichter bij een concreet plan voor jullie initiatief.',
      tip: 'Tip: Stichting !WOON organiseert regelmatig verdiepende trainingen om in groepsvorm jullie visie, missie, plan van aanpak en financiële businessplan te ontwikkelen. Wil je hier meer over weten? Check onze agenda voor deze trainingen.',
      downloadPdfLabel: 'PDF Downloaden',
    },
    landingPage: {
      title: 'Maak je woondroom werkelijkheid.',
      description:
        'Wonen zoals jij het wilt: meer gemeenschap, meer groen, beter betaalbaar. CrowdBuilding helpt je op weg. Ontdek hoe samen bouwen en wonen werkt, sluit je aan bij een groep of start je eigen initiatief.', // Comment LF: I've previously reviewed this copy in Figma and provided suggestions.
      searchPlaceholder: 'Zoek op trefwoord, gemeente of provincie',
      searchButton: 'Zoek',
      modernAFrameHouse: 'Modern A-frame House', // Commment LF: need context
      erfdelen: 'Erfdelen',
      sharedLivingSpacesAndCommunityPlots:
        'Shared living spaces and community plots', // Comment LF: need context
      meergeneratiewonen: 'Meergeneratiewonen',
      multiGenerationalLivingCommunities:
        'Multi-generational living communities', // Comment LF: need context
      whyCrowdBuilding: 'Waarom CrowdBuilding?',
      whyCrowdBuildingDescription:
        'Woningbouw moet radicaal anders: duurzamer, socialer en betaalbaarder. Door samen te bouwen met je toekomstige buren bepaal je zelf hoe je woont, bespaar je kosten en ontstaat er een hechte gemeenschap.',
      signUpButton: 'Meld je aan',
      maintenanceMessage:
        'We voeren momenteel onderhoud uit aan ons platform. Probeer het later opnieuw.',
      discoverSection: {
        title: 'Initiatieven',
        subTitle:
          'Vind of start een initiatief dat bij jouw woondroom past en kom met elkaar in contact.',
        seeMore: 'Bekijk alles',
        emptyTitle: 'Geen initiatieven gevonden',
      },
      housingFormsSection: {
        title: 'Populaire Woonvormen',
        subTitle:
          'Hoe wil jij wonen? Volg je favoriete woonvormen voor informatie, inspiratie en discussie.',
        seeMore: 'Bekijk alles',
        emptyTitle: 'Geen woonvormen gevonden',
      },
      aboutSection: {
        title: 'Hoe werkt CrowdBuilding?',
        subTitle:
          'Collectief bouwen en wonen is samen met anderen je ideale woonplek realiseren. Ontwerp en bouw je eigen woonomgeving samen met een groep, of vind jouw plek in een bestaande gemeenschap. Het kan allemaal. Maar hoe begin je? Lees meer in onze Kennishub.',
        seeMore: 'Lees meer',
        cta: [
          {
            title: 'Vorm een groep',
            subtitle:
              'Vind of start een initiatief en kom met elkaar in contact.',
          },
          {
            title: 'Vind een locatie',
            subtitle: 'Vind kavels en gebouwen geschikt voor collectieve bouw.',
          },
          {
            title: 'Raadpleeg experts',
            subtitle: 'Vind de juiste hulp voor iedere fase van je initiatief.',
          },
        ],
      },
      prikbordSection: {
        title: 'Nieuw op het prikbord',
        subTitle: 'Zoek je mensen, een plek of expertise? Hier vind je elkaar.',
        seeMore: 'Naar het prikbord',
      },
      blogSection: {
        title: 'Verhalen',
        subTitle: 'Lees hoe anderen succesvol samenbouwen.',
        seeMore: 'Bekijk alles',
      },
      statsAndCtaSection: {
        title: 'Sluit je aan bij een groeiende beweging',
        subTitle:
          'Elke dag zetten mensen en initiatieven de volgende stap naar het realiseren van hun woondroom. Meld je gratis aan en begin vandaag.',
        cta: [
          {
            title: 'Start een initiatief',
          },
          {
            title: 'Meld je aan',
          },
        ],
        statistics: [
          {
            number: '8k',
            subtitle: 'Gebruikers',
          },
          {
            number: '95+',
            subtitle: 'Locaties',
          },
          {
            number: '170+',
            subtitle: 'Initiatieven',
          },
          {
            number: '65+',
            subtitle: 'Experts',
          },
        ],
      },
      newsletterSection: {
        title: 'Meld je aan voor de nieuwsbrief',
        subTitle:
          'Ontvang inspiratie, nieuws en evenementen over samen bouwen en wonen.',
        placeholder: 'E-mailadres',
        successMessage: 'Bedankt voor je aanmelding!',
      },
    },
    forMunicipalities: {
      hero: {
        badge: 'Voor gemeenten met grond',
        title: 'Jullie hebben kavels, maar geen proces',
        description:
          "Dan zijn jullie bij ons aan het goede adres. CrowdBuilding helpt gemeenten met een bewezen proces om kavels uit te geven voor collectief wonen. Eerlijk, efficiënt en zonder extra druk op je collega's. Ben jij verantwoordelijk voor het dossier wonen in jouw gemeente? Lees hier hoe wij jou kunnen helpen.",
      },
      residentTestimonials: {
        title: 'Bewoners vertellen',
        intro:
          'Dit zijn de mensen voor wie je het doet. Hun verhaal begon met een gemeente die ja zei.',
      },
      partners: {
        title: 'Werkt al voor:',
      },
      painPoints: {
        title: 'Pijnpunten',
        intro:
          'In onze gesprekken met beleidsmedewerkers Wonen horen we steeds dezelfde geluiden. De ambitie voor collectief wonen is er – maar de tijd, het overzicht, de juiste kennis en het proces ontbreken.',
        items: {
          noTime: {
            title: 'Geen tijd voor groepsbegeleiding',
            description:
              'Er is beleid, maar geen capaciteit. Groepen begeleiden kost tijd die je niet hebt.',
          },
          enoughInitiatives: {
            title: 'Zijn er genoeg initiatieven?',
            description:
              'Groepen melden zich - maar je weet niet hoeveel het er zijn, hoe serieus ze zijn, of wat ze nodig hebben om verder te komen.',
          },
          noProcess: {
            title: 'Kavels, maar geen proces',
            description:
              'Je wil kavels uitgeven voor collectief wonen, alleen ontbreekt een gestandaardiseerd selectietraject.',
          },
          noExpertise: {
            title: 'Te weinig expertise in huis',
            description:
              'Collectief wonen faciliteren vraagt specifieke kennis en die zit niet in je eigen team. Je hebt een partner nodig die het proces kent.',
          },
        },
      },
      solutions: {
        title: 'Oplossingen',
        subtitle: 'Wat CrowdBuilding biedt',
        intro:
          'CrowdBuilding sluit aan op je bestaande beleid en processen. Geen extra druk op je team, wel direct resultaat en inzicht.',
        groupGuidance: {
          badge: 'Groepsvorming',
          title: 'Groepsbegeleiding',
          subtitle:
            'Wij begeleiden de initiatieven, jij houdt tijd over voor de rest.',
          description:
            'Het samenbrengen van woningzoekenden kost tijd die jij niet hebt. CrowdBuilding werft, matcht en begeleidt actief tot een initiatief dat op één lijn zit en weet wat het betekent om samen te bouwen.',
        },
        kaartenbak: {
          badge: 'Kaveluitgifte',
          title: 'Kaartenbak',
          subtitle:
            'Een bewezen uitgifteproces, zodat jij je energie steekt in de inhoud, niet in de organisatie.',
          description:
            'CrowdBuilding neemt het uitgifteproces van je over. Van werving en selectie tot de definitieve toewijzing. Al succesvol ingezet in Utrecht en Rotterdam, en klaar om in jouw gemeente te gebruiken.',
        },
        insight: {
          badge: 'Overzicht & netwerk',
          title: 'Inzicht in elk initiatief',
          subtitle:
            'Wij brengen de initiatieven in beeld, jij bepaalt de volgende stap.',
          description:
            'Met ons lokale netwerk en gerichte campagnes zorgen we dat de juiste mensen zich melden. Via je eigen gemeentedashboard zie je live waar elk initiatief staat en wat de volgende stap is, inclusief rapportages.',
        },
        knowledge: {
          badge: 'Kennispartners',
          title: 'Kennisdeling',
          subtitle: 'Wij brengen de expertise mee die jij nodig hebt.',
          description:
            'Niet elke gemeente heeft een expert in collectief wonen in huis - en dat hoeft ook niet. Via onze vraagbaak, e-learning en een netwerk van lokale en landelijke experts staat CrowdBuilding altijd voor je klaar, zodat jij de regie houdt zonder alles zelf te hoeven weten.',
        },
      },
      faq: {
        title: 'Veelgestelde vragen van gemeenten:',
        subtitle:
          'Geen verkooppraatje, gewoon de vragen die gemeenten stellen — en de eerlijke antwoorden. Mis je er een? Laat het weten.',
        items: {
          time: {
            question: 'Kost dit niet juist meer tijd?',
            answer:
              'Nee. Voor een vast jaarlijks bedrag krijg je een werkend platform — inclusief onderhoud, beveiliging, updates en doorontwikkeling. Geen bouwkosten, geen IT-traject, geen verborgen meerkosten. Een eigen tool laten bouwen en onderhouden kost al snel het tienvoudige in jaar één, plus de uren die je er intern in stopt.',
          },
          self: {
            question: 'Kunnen we dit niet zelf doen?',
            answer:
              'Natuurlijk kan dat. Maar de vraag is of je dat wilt. Wij hebben deze infrastructuur al gebouwd, samen met andere gemeenten en honderden initiatiefgroepen. Jij hoeft niet opnieuw uit te vinden hoe je initiatieven registreert, fases bijhoudt en transparant communiceert. Je sluit aan op wat er staat — en betaalt alleen voor het gebruik.',
          },
          live: {
            question: 'Hoe snel zijn we live?',
            answer:
              'Binnen enkele weken. Het platform draait al. We richten je gemeentepagina en -profiel in, je tekent de gebruiksovereenkomst, en je bent live. Geen ontwikkelfase, geen pilot van een jaar.',
          },
          safe: {
            question: 'Is het veilig?\nOnze data is gevoelig.',
            answer:
              'Ja. Het platform voldoet aan de eisen die gemeenten stellen voor toegankelijkheid en privacy, en we werken volgens GIBIT 2023 — de standaard voor gemeentelijke IT-inkoop. Voor persoonsgegevens treden we op als verwerker, met een aparte verwerkersovereenkomst. Jij houdt regie over je data.',
          },
          stop: {
            question: 'Wat als het ons niet bevalt?',
            answer:
              'Dan stop je. Je kiest zelf de looptijd: één jaar, drie jaar, of één jaar met optionele verlenging. Opzeggen kan schriftelijk, met één maand opzegtermijn voor het einde van de contractperiode. De gemeentepagina kun je tussentijds stopzetten — we plaatsen dan een neutrale melding met verwijzing naar alternatieven. Geen lock-in.',
          },
        },
      },
      contact: {
        title: 'Plan een vrijblijvend gesprek',
        description:
          'Benieuwd wat CrowdBuilding voor jouw gemeente kan betekenen? We denken graag met je mee - zonder verplichtingen.',
        buttonLabel: 'Plan een gesprek',
        people: {
          sascha: {
            role: 'Mede-oprichter en partnerships lead',
          },
          freddie: {
            role: 'Partnerships',
          },
        },
      },
      planDemoButton: 'Plan een demo',
    },
    mediaGallery: {
      allMedia: 'Alle media',
    },
    messageComposeModal: {
      newMessage: 'Nieuw bericht',
      recipient: 'Aan',
      subject: 'Onderwerp',
      message: 'Bericht',
      send: 'Stuur bericht',
    },
    share: {
      email: 'E-mail',
      x: 'X',
      facebook: 'Facebook',
      whatsapp: 'WhatsApp',
      copyLink: 'Link kopiëren',
      copiedLink: 'Link gekopieerd!',
    },
    socialShareModal: {
      title: 'Deel deze pagina',
      close: 'Sluiten',
    },
    nav: {
      find: 'Vinden',
      findDescription: 'Vind initiatieven en woongroepen die bij jou passen',
      start: 'Starten',
      learn: 'Leren',
      aboutUs: 'Over',
      discussions: 'Prikbord',
      logIn: 'Log in',
      signUp: 'Meld je aan',
      logOut: 'Uitloggen',
      dashboardHome: 'Overzicht',
      profile: 'Profiel',
      megaMenu: {
        findMenu: {
          initiatives: {
            label: 'Zoek initiatieven',
            description: 'Bekijk collectieve zelfbouwgroepen en sluit je aan.',
          },
          livingGroups: {
            label: 'Zoek woongroepen',
            description: 'Vind bestaande woongroepen die bewoners zoeken.',
          },
          plots: {
            label: 'Zoek locaties',
            description:
              'Vind kavels of gebouwen om je woondroom te realiseren.',
          },
          region: {
            label: 'Zoek in jouw regio',
            description: 'Bekijk initiatieven, kavels en kom in contact.',
          },
          housingForms: {
            label: 'Zoek woonvormen',
            description:
              'Tiny houses of zelfbouwstraat? Volg je favoriete woonvormen.',
          },
          experts: {
            label: 'Zoek expert',
            description: 'Van procesbegeleiders tot architecten.',
          },
        },
        startMenu: {
          citizens: {
            label: 'Voor initiatiefnemers',
            description:
              'Start een nieuw initiatief of meld een bestaand initiatief aan en vind geïnteresseerden.',
            links: {
              startInitiative: 'Start een initiatief op CrowdBuilding',
              registerProject: 'Meld bestaand project/woongroep aan',
            },
          },
          companies: {
            label: 'Voor ontwikkelaars',
            description:
              'Zoek je als professionele partij enthousiaste bewoners voor een project? Start hier.',
          },
        },
        learnMenu: {
          events: {
            label: 'Agenda',
            description:
              'Ontdek alle evenementen van CrowdBuilding en onze partners.',
          },
          knowledgeHub: {
            label: 'Kennishub',
            description:
              'Hier vind je alle informatie die je nodig hebt om jouw woondroom realiteit te maken.',
            links: {
              whatCanIDo: 'Wat kan ik op CrowdBuilding?',
              createAccount: 'Hoe maak ik een account aan?',
              startInitiative: 'Hoe start ik zelf een initiatief?',
            },
          },
          elearning: {
            label: 'E-learning',
            description:
              'Leer stap voor stap alles over collectieve zelfbouw met onze gratis e-learnings.',
          },
          stories: {
            label: 'Verhalen',
            description: 'Lees hoe anderen succesvol samenbouwen.',
          },
        },
        aboutUsMenu: {
          about: {
            label: 'Over CrowdBuilding',
            description:
              'Hoe wij bijdragen aan een eerlijke en duurzame woningmarkt.',
            links: {
              stewardOwned: 'Steward-owned',
              joinUs: 'Werken bij',
              contact: 'Contact',
            },
          },
          legal: {
            label: 'Juridisch',
            description: 'Algemene voorwaarden en privacybeleid.',
          },
          partner: {
            label: 'Word Partner',
            links: {
              municipalities: 'Gemeenten',
              provinces: 'Provincies',
              experts: 'Experts',
            },
          },
        },
        shared: {
          knowledgeHub: shared.knowledgeHub,
          howCrowdBuildingWorksLink: 'Hoe werkt CrowdBuilding?',
          howCrowdBuildingWorksDescription:
            'Praktische uitleg en tips\nover hoe je het platform\ngebruikt',
          whatIsCollectiveSelfConstruction: 'Wat is collectieve zelfbouw?',
          isCollectiveLivingAffordable: 'Is collectief wonen betaalbaar?',
          storiesLink: shared.storiesLink,
          storiesDescription: 'Lees hoe anderen succesvol\nsamenbouwen',
          governmentSectionLink: 'Overheidsloket',
          governmentSectionDescription:
            'Bekijk beleid, bouwkavels,\ninitiatieven en subsidies per regio.',
          relevantNow: 'Nu relevant',
        },
      },
    },
    pageNames: {
      home: 'Home',
      initiatives: 'Initiatieven',
      housingForms: 'Woonvormen',
      agenda: 'Agenda',
      plots: 'Locaties',
      serviceProviders: 'Experts',
      regions: "Regio's",
    },
    dashboardPage: {
      title: 'Dashboard',
    },
    initiativePage: {
      applyTooltip: 'Meld je aan en kom in contact',
      followTooltip: shared.followTooltip,
      membersTooltip: 'Online deelnemers aan dit initiatief',
      unknownLocation: shared.unknownLocation,
      notSpecified: shared.notSpecified,
      apply: 'Aanmelden interesselijst',
      leave: 'Initiatief verlaten',
      withdrawApplication: 'Afmelden interesselijst',
      follow: shared.follow,
      following: shared.following,
      share: 'Delen',
      initiative: shared.initiative,
      follower: {
        singular: 'Volger',
        plural: 'Volgers',
      },
      member: {
        singular: 'Deelnemer',
        plural: 'Deelnemers',
      },
      admin: {
        singular: 'Beheerder',
        plural: 'Beheerders',
      },
      overview: 'Overzicht',
      thread: 'Prikbord',
      events: 'Agenda',
      overviewTab: {
        whoDoWeLookFor: 'Wie we zoeken',
        searchArea: 'Zoekgebied',
        features: 'Kenmerken',
        contact: 'Contactinformatie',
      },
      phases: phaseTranslations,
      modalApplyConfirmation:
        'Door je aan te melden, kom je op de interesselijst van initiatief {0}. We vragen de beheerders contact met je op te nemen.',
      modalLeaveConfirmation:
        'Weet je zeker dat je initiatief {0} wil verlaten?',
      modalWithdrawConfirmation:
        'Weet je zeker dat je je wil afmelden voor de interesselijst van initiatief {0}?',
      modalApplyTitle: 'Meld je aan',
      modalDefaultTitle: shared.attention,
      overviewFeaturesKeys: {
        location: 'Plaats',
        phase: 'Initiatief fase',
        developmentForm: 'Ontwikkelvorm',
        numberOfHouseholds: 'Huishoudens',
        livingEnvironment: 'Woonmilieu',
        targetAudience: 'Doelgroepen',
        tags: 'Tags',
        amenities: 'Voorzieningen',
      },
      contactInformationKeys: {
        contactPerson: 'Contactpersoon',
      },
      noEvents: 'Geen evenementen gekoppeld.',
    },
    eventPage: {
      address: 'Adres',
      joinEvent: 'Deelnemen',
      leaveEvent: 'Niet meer deelnemen',
      attendEvent: 'Bijwonen',
      openInLuma: 'Open evenement',
      organisers: 'Organizers ',
      noContent: 'Geen evenementen.',
      members: shared.members,
      eventEnded: 'Dit evenement is afgelopen',
      addToCalendar: 'Agenda',
      share: 'Delen',
      addToCalendarModal: {
        title: 'Toevoegen aan agenda',
        googleCalendar: 'Google Agenda',
        outlook: 'Outlook',
        appleCalendar: 'Apple Agenda',
        close: 'Sluiten',
      },
    },
    plotPage: {
      deadline: 'Deadline',
      officialOffering: 'CrowdBuilding inschrijving',
      privateOffering: 'Externe inschrijving',
      applicationClosesInLabel: 'Inschrijving sluit over {0} dagen',
      numberOfUnitsLabel: 'Aantal woningen {0}',
      applicationStatus: {
        applicationOpen: 'Inschrijving open',
        applicationClosed: 'Inschrijving gesloten',
        inPreparation: 'In voorbereiding',
      },
      plotRegistryRequirementAlert:
        'Let op! Voor deze inschrijving is een {0} vereist.',
      plotRegistryRequirementAlertLinkText: 'kaartenbak registratie',
      registerInitiative: 'Initiatief inschrijven',
      follow: 'Interesselijst',
      share: 'Delen',
      offeredBy: 'Aangeboden door',
      initiative: shared.initiative,
      follower: {
        singular: 'Volger',
        plural: 'Volgers',
      },
      interestListText: 'op de interesselijst',
      overview: 'Overzicht',
      applicationProcedure: 'Inschrijfprocedure',
      documents: 'Documenten',
      thread: 'Prikbord',
      overviewTab: {
        info: 'Info',
        whatIsNext: 'Wat komt er',
        location: shared.location.singular,
        plan: 'Planning',
        contact: 'Contactinformatie',
        features: 'Algemeen',
      },
      overviewFeaturesKeys: {
        offerType: 'Type aanbod',
        buildingType: 'Bebouwingstype',
        developmentForm: 'Ontwikkelvorm',
        ownershipType: 'Eigendomstype',
        livingEnvironment: 'Woonmilieu',
        numberOfUnits: 'Aantal bouwunits',
      },
      contactInformationKeys: {
        providerType: 'Type aanbieder',
        organization: 'Organisatie',
        contactPerson: 'Naam',
        email: 'E-mailadres',
        website: 'Website',
      },
      threadTab: {
        titleLabel: 'Titel',
        titlePlaceholder: 'Optionele titel voor je bericht',
        postPlaceholder: 'Typ hier je bericht',
        maxCharactersReached: 'Je hebt het maximale aantal tekens bereikt.',
        noPostsTitle: 'Deze Prikbord heeft nog geen berichten.',
        noPostsDescription: 'Stel als eerste een vraag of doe een oproep.',
        alertTitle: 'Start een gesprek',
        alertDescription: 'Plaats een bericht en laat de community antwoorden.',
        postOnPrikbord: 'Ook plaatsen op algemeen prikbord',
        postOnPrikbordTooltip:
          'Als dit is ingeschakeld, verschijnt je bericht ook op de algemene discussiepagina.',
        placePost: 'Bericht plaatsen',
        newPost: 'Nieuw bericht',
        tagsLabel: 'Tags',
      },
      modalCopy: {
        official:
          'Je interesse in deze kavel wordt zichtbaar voor andere CrowdBuilders. Zij kunnen je een bericht sturen. Zo heb je kans om samen een initiatief te vormen voor deze inschrijving.',
        nonOfficial:
          'Je interesse in deze kavel wordt zichtbaar voor andere CrowdBuilders. Zij kunnen je een bericht sturen. Zo heb je kans om samen een initiatief te vormen voor deze inschrijving.\n\nDe officiële inschrijving loopt via de website van de kavel-aanbieder.',
      },
      followModal: {
        title: 'Aanmelden Interesselijst',
        prompt: 'Wil je je aanmelden als initiatief of individu?',
        asInitiative: 'Als initiatief',
        asIndividual: 'Als individu',
        selectInitiative: 'Selecteer een initiatief',
      },
      unfollowModal: {
        title: 'Afmelden Interesselijst',
        prompt: 'Wat wil je afmelden?',
        asInitiative: 'Initiatief',
        asIndividual: 'Individu',
        selectInitiative: 'Selecteer initiatieven om af te melden',
      },
      sendMessage: shared.sendMessage,
    },
    discussions: {
      title: 'Prikbord',
      subTitle:
        'Zoek je woonruimte, leden of juist expertise? Of heb je iets te bieden? Plaats je oproep en word gevonden',
      createButton: 'Plaats een bericht',
      filterByCategory: 'Filter op categorie',
      filterByLocation: 'Filter op',
      myPosts: 'Mijn berichten',
      locationPlaceholder: 'Locatie',
      locationGroupRegions: 'Locaties',
      locationGroupHousingForms: 'Woonvormen',
      regionPlaceholder: 'Regio',
      housingFormPlaceholder: 'Woonvorm',
      clearFilters: 'Filters wissen',
      searchPlaceholder: 'Zoek berichten...',
      postCount: '{0} berichten',
      loading: 'Berichten laden...',
      emptyTitle: 'Nog geen berichten',
      emptyDescription: 'Wees de eerste die iets deelt op het prikbord.',
      postedIn: 'geplaatst in {0}',
      editedLabel: 'Bewerkt',
      menuEdit: 'Bewerken',
      menuDelete: 'Verwijderen',
      menuCopyLink: 'Link kopiëren',
      cancel: 'Annuleren',
      deleteConfirm: 'Verwijderen',
      deleteConfirmDescription:
        'Weet je zeker dat je dit bericht wilt verwijderen?',
      deleteSuccessTitle: 'Gelukt!',
      deleteSuccess: 'Je bericht is verwijderd.',
      linkCopied: 'Link gekopieerd naar klembord',
      createPost: {
        title: 'Deel je bericht',
        editTitle: 'Bericht bewerken',
        saveChanges: 'Wijzigingen opslaan',
        titleLabel: 'Titel',
        titlePlaceholder: 'Vat je bericht samen in één zin',
        titleRequired: 'Een titel is verplicht',
        titleMinLength: 'Titel moet minimaal {0} tekens bevatten',
        categoryRequired: 'Selecteer minimaal één categorie',
        messageLabel: 'Je bericht',
        messageMinLength: 'Je bericht moet minimaal {0} tekens bevatten',
        maxCharacters: 'Max 800 tekens',
        maxCharactersReached: 'Je hebt het maximale aantal tekens bereikt.',
        messagePlaceholder:
          'Vertel wat je zoekt of aanbiedt. Wees concreet: wie, wat en waar?',
        attachLabel: 'Voeg een foto of pdf toe',
        tagsLabel: 'Wat wil je doen?',
        locationLabel: 'Gemeente of provincie',
        locationPlaceholder: 'Rotterdam',
        locationNotFound: 'Gemeente niet gevonden',
        locationInactiveMessage:
          'Deze gemeente of provincie is nog niet actief, maar je bericht verschijnt wel op het prikbord.',
        initiativeLabel: 'Selecteer initiatief',
        initiativePlaceholder: 'Kies een initiatief',
        postAsAdminLabel: 'Plaats namens je initiatief',
        destinationSectionHeader: 'Waar verschijnt je bericht?',
        postElsewhereLabel: "Toon je bericht ook op een andere pagina",
        postAsAdminTooltip:
          'Je initiatief staat dan als afzender bij je bericht. Lezers klikken direct door naar jullie pagina.',
        postElsewhereTooltip:
          "Je bericht verschijnt dan ook op de pagina's van jouw regio en woonvorm. Zo zien meer mensen het.",
        destinationTypeLabel: 'Soort pagina',
        destinationTypePlaceholder: 'Kies een soort pagina',
        destinationLabel: 'Welke pagina?',
        destinationPlaceholder: 'Kies een {0}',
        typeInitiative: 'Initiatief',
        typeHousingForm: 'Woonvorm',
        typeRegion: 'Regio',
        typeMunicipality: 'Gemeente',
        typePlot: 'Kavel',
        postOnPrikbord: 'Ook plaatsen op algemeen prikbord',
        postOnPrikbordTooltip:
          'Wanneer ingeschakeld, verschijnt je bericht ook op de algemene prikbordpagina.',
        discard: 'Annuleren',
        placePost: 'Plaats je bericht',
      },
    },
    post: {
      like: 'Leuk',
      reply: 'Reageer',
      oneLike: 'Leuk',
      manyLikes: 'Leuk',
      oneReply: 'Reactie',
      manyReplies: 'Reacties',
      typeYourReply: 'Reageer...',
      maxCharactersReached: 'Je hebt het maximale aantal tekens bereikt.',
      loadMoreReplies: 'Laad meer reacties',
      loadMoreComments: 'Laad meer comments',
    },
    profilePage: {
      bio: 'Bio',
      livingDream: 'Woondroom',
      media: 'Media',
      connect: 'Maak contact',
      placeOfResidence: 'Woonplaats',
      initiatives: 'Initiatieven',
      followedHousingForms: 'Volgt woonvormen',
      searchRegion: 'Zoekt in regio',
      livingEnvironment: 'Woonmilieu',
      interests: 'Interessess',
      emptyProfileMessage: 'Heeft zich nog niet voorgesteld.',
    },
    regionPage: {
      managedBy: 'Beheerder',
      pageTabTitle: {
        overview: '',
        discussion: 'Discussie in {0}',
        initiatives: 'Initiatieven in {0}',
        current: 'Actueel in {0}',
        locations: 'Locaties in {0}',
        knowledgeHub: 'Kennishub van {0}',
        municipalities: 'Gemeenten in {0}',
        developmentAreas: 'Ontwikkelgebieden in {0}',
        stepByStep: 'Stappenplan in {0}',
        subsidies: 'Subsidies in {0}',
        experts: 'Experts uit {0}',
      },
      overview: 'Home',
      discussion: 'Prikbord',
      initiatives: 'Initiatieven',
      knowledgeHub: shared.knowledgeHub,
      initiativesIn: 'Initiatieven in {0} ({1})',
      current: 'Actueel',
      developmentAreas: 'Ontwikkelgebied',
      stepByStep: 'Stappenplan',
      downloadStepByStepPdf: 'PDF downloaden',
      locations: 'Locaties',
      locationsIn: 'Locaties in {0} ({1})',
      subsidies: 'Subsidies',
      experts: shared.experts,
      more: 'Meer',
      noInitiativesTitle: 'Wees de eerste',
      noInitiativesCta: 'Start initiatief',
      noInitiativesDescription: 'Wees de eerste, maak je initiatief aan',
      noLocationsTitle: 'Nog geen matchende locaties',
      noLocationsDescription: 'Meld zelf een gebouw of kavel aan.',
      nutshell: {
        inAnutshell: ' in een oogopslag',
      },
      events: 'Agenda',
      news: 'Nieuws',
      latestDiscussions: 'Nieuw op het prikbord in {0}',
      seeMore: 'Naar het prikbord',
      popularInitiatives: 'Populaire initiatieven',
      popularHousingFormsIn: 'Populaire woonvormen in',
      ambassadors: shared.ambassadors,
      networksAndSupportGroupsIn: 'Netwerken en Steunpunten in',
      serviceProvidersIn: 'Experts in',
      topicCommunitiesIn: 'Steunpunten in',
      municipalities: 'Gemeenten',
      lockedMunicipalityHeader: 'Gemeente {0} is nog niet online',
      lockedMunicipalityFollowed: shared.lockedPageFollowed,
      lockedMunicipalityBody:
        'We werken eraan om ook deze gemeente op CrowdBuilding beschikbaar te maken. Laat zien dat er belangstelling is en hoor als eerste wanneer {0} online staat.',
      lockedMunicipalityBodyFollowed: shared.lockedPageFollowedText,
      lockedProvinceHeader: 'Provincie {0} is nog niet online',
      lockedProvinceFollowed: shared.lockedPageFollowed,
      lockedProvinceBody:
        'We werken eraan om ook deze provincie op CrowdBuilding beschikbaar te maken. Laat zien dat er belangstelling is en hoor als eerste wanneer {0} online staat.',
      lockedProvinceBodyFollowed: shared.lockedPageFollowedText,
      followThePage: 'Volg de pagina',
      pageFollowed: 'Volgend',
      sorting: {
        newestFirst: 'Nieuwste eerst',
        oldestFirst: 'Oudste eerst',
        popular: 'Populair eerst',
      },
      filters: {
        title: 'Filters',
        phase: 'Fase',
        lookingForMembers: 'Op zoek naar leden',
        developmentForm: 'Ontwikkelvorm',
        apply: 'Toepassen',
        back: 'Terug',
        yes: shared.yes,
        no: shared.no,
        noPreference: shared.noPreference,
      },
    },
    dashboard: {
      event: {
        creation: {
          createEvent: 'Evenement aanmaken',
          back: 'Terug',
          next: 'Volgende',
          previewAndSave: 'Voorbeeld & Opslaan',
          backToEditing: 'Terug naar bewerken',
          publish: 'Publiceren',
          closeModalTitle: 'Evenement aanmaken verlaten?',
          closeModalContent:
            'Weet je zeker dat je het aanmaken van het evenement wilt verlaten?',
          steps: {
            generalInformation: {
              title: 'Algemene informatie',
              description:
                'Geef je evenement een goede naam en een duidelijke beschrijving.',
            },
            locationCover: {
              title: 'Locatie & Omslagafbeelding',
              description:
                'Waar vindt jouw evenement plaats? Als je het nog niet zeker weet, vergeet dan niet het later bij te werken.',
            },
            eventSettings: {
              title: 'Evenementinstellingen',
              description:
                'Beslis hoeveel mensen je kunt ontvangen en voor wie dit evenement is.',
            },
            preview: {
              title: 'Voorbeeld',
              description:
                'Zo ziet jouw evenement eruit voor de deelnemers. Je kunt altijd teruggaan en dingen aanpassen.',
            },
          },
          isGroupEventLabel: 'Is dit een groepsevenement?',
          groupEvent: 'Groepsevenement',
          oneOnOne: '1 op 1',
          titleLabel: 'Naam evenement',
          titlePlaceholder: 'Een korte maar beschrijvende naam',
          introLabel: 'Korte beschrijving',
          introPlaceholder: 'Een korte maar duidelijke introductie',
          contentLabel: 'Beschrijving',
          contentPlaceholder: 'Waar gaat dit evenement over?',
          singleDay: 'Eén dag evenement',
          multiDay: 'Meerdaags evenement',
          dateEndLabel: 'Einddatum',
          dateEndPlaceholder: 'Selecteer einddatum',
          dateStartLabel: 'Startdatum',
          dateStartPlaceholder: 'Selecteer startdatum',
          startTimeLabel: 'Starttijd',
          startTimePlaceholder: 'Selecteer starttijd',
          endTimeLabel: 'Eindtijd',
          endTimePlaceholder: 'Selecteer eindtijd',
          offlineEvent: 'Offline evenement',
          onlineEvent: 'Online evenement',
          locationLabel: 'Adres',
          locationPlaceholder: 'Voer het adres in',
          meetingLinkLabel: 'Vergaderlink',
          meetingLinkPlaceholder: 'https://',
          meetingLinkTooltip:
            'Deel een vergaderlink van elke videoconferentietool zoals Zoom, Teams, Google Meet, etc.',
          coverImageLabel: 'Omslagafbeelding',
          coverImageInfo:
            'Zorg ervoor dat de afbeelding in .jpg-, .jpeg-, .png- of .webp-formaat.',
          limitLabel: 'Maximum aantal deelnemers',
          limitPlaceholder: 'Bijvoorbeeld: 10',
          enableWaitlistLabel: 'Wachtlijst inschakelen',
          enableWaitlistTooltip:
            'Wanneer ingeschakeld, kunnen mensen zich op een wachtlijst plaatsen als het evenement vol is.',
          visibilityLabel: 'Wie kan dit evenement zien en eraan deelnemen',
          visibilityPlaceholder: 'Selecteer',
          visibilityTooltip:
            'Leden: zichtbaar voor initiatiefleden. Leden + Volgers: zichtbaar voor initiatiefleden en volgers. Iedereen: zichtbaar voor iedereen.',
          visibilityMembers: 'Leden',
          visibilityMembersFollowers: 'Leden + Volgers',
          visibilityEveryone: 'Iedereen',
          reminderLabel: 'Herinnering',
          reminderTooltip:
            'Deelnemers ontvangen automatisch een herinneringsmail 24 uur en 2 uur voor het evenement.',
          viewEvent: 'Bekijk evenement',
          successTitle: 'Gelukt! Jouw evenement is gepubliceerd.',
          successSubtext:
            'Je volgers en leden worden hierover via e-mail op de hoogte gesteld. Het is ook zichtbaar op het prikbord. Deel het gerust.',
          validation: {
            titleMin: 'Naam evenement moet minimaal 3 tekens bevatten',
            contentRequired: 'Beschrijving is verplicht',
            startDateRequired: 'Startdatum is verplicht',
            endDateRequired: 'Einddatum is verplicht',
            endBeforeStart: 'Einddatum moet na startdatum liggen',
            addressRequired: 'Locatie is verplicht',
            meetingLinkInvalid: 'Voer een geldige URL in',
            limitMin: 'Voer minimaal 1 deelnemer in',
            visibilityRequired: 'Selecteer minimaal één zichtbaarheidsoptie',
          },
        },
      },
      yourInitiatives: 'Jouw initiatieven',
      noteworthyInitiatives: 'Actuele initiatieven',
      nav: {
        home: 'Overzicht',
        messages: shared.messages,
        initiatives: 'Mijn initiatieven',
        profile: 'Profiel',
        preferences: 'Voorkeuren',
        following: 'Favorieten',
      },
      pageContentEditor: {
        addBlock: 'Voeg tekstblok toe',
        creationNewBlockHeading: 'Nieuw tekstblok',
        creationTitleLabel: 'Titel van dit tekstblok',
        removeBlock: 'Tekstblok verwijderen',
        moveUp: 'Omhoog',
        moveDown: 'Omlaag',
        titleLabel: 'Titel van dit blok',
        titlePlaceholder: 'Bijvoorbeeld: Onze aanpak',
        bodyLabel: 'Jouw tekst',
        bodyPlaceholder:
          'Vertel meer over je initiatief. Houd elke alinea kort, 3 à 4 zinnen werkt het beste.',
        reset: 'Herstellen',
        richTextBold: 'Vet',
        richTextItalic: 'Cursief',
        richTextStrikethrough: 'Doorhalen',
        richTextBulletList: 'Opsommingslijst',
        richTextNumberedList: 'Genummerde lijst',
        richTextLink: 'Link',
        richTextLinkUrlPlaceholder: 'https://...',
        richTextLinkConfirm: 'Link toevoegen',
        richTextLinkCancel: 'Annuleren',
        richTextLinkRemove: 'Link verwijderen',
        richTextLinkNewTab: 'Openen in nieuw tabblad',
      },
      home: {
        title: 'Hallo, {0}',
        welcome: 'Welkom op je dashboard',
        updatesPlaceholder:
          "Vanuit je dashboard beheer je je berichten, initiatieven en profiel, en ontdek je nieuwe initiatieven.\nBinnenkort zie je hier ook updates van initiatieven en pagina's die je volgt.",
        KnowledgeHub: 'Kennishub',
        KnowledgeHubCardTitle: 'Nieuw hier?',
        KnowledgeHubCardDescription:
          'Leer meer over collectief bouwen en wonen in onze kennishub.',
        DiscoverMore: 'Zoek',
        DiscoverCardTitle: 'Zoek je een huis?',
        DiscoverCardDescription:
          'Vind een woongroep op zoek naar bewoners, of doe mee met een initiatief dat nog in de maak is.',
        StartInitiative: 'Start initiatief',
        StartInitiativeCardTitle: 'Zelf een initiatief starten?',
        StartInitiativeCardDescription:
          'Start zelf een initiatief en vind geïnteresseerden, kavels en meer.',
        StoriesTitle: 'Laat je inspireren door\n anderen',
      },
      messages: {
        messages: shared.messages,
        inbox: 'Inbox',
        openMessages: 'Gelezen',
        peopleToMessageTitle: 'Jouw contacten',
        peopleToMessageDescription:
          'Als beheerder van een initiatief kan je een bericht sturen naar al je volgers en (potentiële) deelnemers. Als deelnemer of volger kan je alleen naar de beheerder berichten sturen.',
        allMessages: 'Alle berichten',
        followedInitiatives: 'Initiatieven die ik volg',
        from: 'van',
        sendMessage: 'Stuur bericht',
        newMessage: 'Nieuw Bericht',
        subject: 'Onderwerp:',
        noSubject: 'Geen onderwerp',
        typeYourReply: 'Reageer...',
        noMessagesPlaceholder: 'No messages',
        emptyStateTitle: 'Jouw berichten',
        emptyStateSubtitle:
          'Hier vind je al je verstuurde of ontvangen berichten. Stuur een bericht naar een beheerder en start een gesprek.',
        messageSent: 'Je bericht is verzonden',
        loading: shared.loading,
        selectRecipients: 'Selecteer ontvangers',
        addRecipients: 'Ontvangers toevoegen',
        selectAll: 'Alles selecteren',
        deselectAll: 'Alles deselecteren',
        numberOfMembersLabel: 'Je hebt {0}',
        back: shared.back,
        done: 'Klaar',
        members: shared.members,
        followers: shared.followers,
        admins: shared.admins,
        interestList: 'Interesselijst',
        sentMessages: 'Verstuurd',
        showMore: 'Bekijk meer',
        showLess: 'Bekijk minder',
        deletedProfile: 'Dit account is verwijderd',
      },
      profile: {
        title: 'Profiel',
        profileTooltip:
          'Zodra jij een initiatief of locatie volgt, je aanmeldt voor de interesselijst of reageert op een discussie, zien anderen jouw profiel en kan je met elkaar in contact komen door een bericht te sturen via CrowdBuilding.',
        bio: 'Even kennismaken',
        bioEditHint:
          'Vertel iets over jezelf en waar je naar op zoek bent. Zo leren anderen je kennen en vind je sneller initiatieven die bij je passen.',
        pictures: "Foto's",
        media: 'Media',
        about: 'Over mij',
        ageCategory: 'Leeftijdscategorie',
        location: 'Woonplaats',
        numberOfAdults: 'Aantal volwassenen',
        numberOfChildren: 'Aantal kinderen',
        searchRegion: 'Zoekregio',
        housingForm: 'Woonvormen',
        interests: 'Interesses',
        fullName: 'Voor- en achternaam',
        nameErrorMessage: 'Vul je volledige naam in',
        yourRegions: "Jouw zoekregio's",
        selectRegion: 'Selecteer een regio',
        yourHousingForms: 'Jouw woonvormen',
        selectHousingForm: 'Selecteer een woonvorm',
        yourInterests: 'Jouw interesses',
        selectInterest: 'Selecteer een interesse',
        profileChangedSavedToast: 'Uw profielen zijn bijgewerkt.',
        imageUploadHint:
          "Upload foto's die laten zien wie jij bent en hoe je wil wonen.",
        imageUploadAlert:
          'Zorg dat bestanden in .jpg, .jpeg, .png of .webp format zijn en niet groter dan 500KB',
        deleteProfileTitle: 'Account verwijderen',
        deleteProfileConfirmation:
          'Als je jouw account verwijdert, gaan alle gegevens verloren. Als je initiatieven hebt waarbij je de enige beheerder bent, worden deze ook verwijderd. Deze actie kan niet worden teruggedraaid.',
        cancel: shared.cancel,
        confirm: 'Verwijder mijn account',
      },
      preferences: {
        title: 'Voorkeuren',
        notificationSettings: 'Meldingen en updates',
        livingSituationTitle: 'Mijn woondroom',
        livingSituationDescription:
          'Door je woonwensen te delen, kunnen we je relevante initiatieven en locaties laten zien. Deze informatie is niet zichtbaar voor andere gebruikers.',
        housingType: 'Type woonvorm',
        ownershipType: 'Gewenste eigendomssituatie',
        purchaseBudget: shared.purchaseBudget,
        rentalBudget: shared.rentalBudget,
        spaceSize: 'Woningoppervlakte',
        involvement: 'Betrokkenheid',
        houisngTypeOptions: {}, // Now fetched from database
        ownershipOptions: {}, // Now fetched from database
        spaceSizeOptions: {}, // Now fetched from database
        involvementOptions: {}, // Now fetched from database
        updateEmailsTitle: 'Update e-mail',
        updateEmailsSubtitle:
          'Ontvang twee keer per maand een korte update over kavels, initiatieven, verhalen en evenementen.',
        importantNotificationsTitle: 'Belangrijke notificaties',
        importantNotificationsSubtitle:
          "Belangrijke notificaties over initiatieven, woonvormen en regio's die jij volgt. Denk aan nieuwe berichten, reacties in de Discussie-tab en meer.",
        monthlyNewsletterTitle: 'Maandelijkse nieuwsbrief',
        monthlyNewsletterSubtitle:
          'Maandelijks het laatste uitgebreide nieuws over CrowdBuilding, uitgelichte initiatieven, kansen, evenementen en meer.',
        crowdBuildingIntroductionTitle: 'CrowdBuilding introductie',
        crowdBuildingIntroductionSubtitle:
          'E-mailreeks over hoe je CrowdBuilding kunt gebruiken.',
        regionalNotificationsTitle: "Regio's die ik volg",
        regionalNotificationsSubtitle:
          'Updates over nieuws, aanbod, subsidies en populaire discussies.',
        initiativesNotificationsTitle: 'Initiatieven die ik volg',
        initiativesNotificationsSubtitle:
          'Updates over populaire discussies, evenementen en berichten\nvan de beheerder(s)',
        houusingFormsNotificationsTitle: 'Woonvormen updates',
        houusingFormsNotificationsSubtitle:
          "Activiteiten op de woonvormpagina's die jij volgt.",
        crowdBuildingUpdatesNotificationsTitle: 'Platform updates',
        crowdBuildingUpdatesNotificationsSubtitle:
          'Nieuws en updates over functionaliteiten op CrowdBuilding.',
        crowdBuildingNewsNotificationsTitle: 'Crowdbuilding nieuwsbrieven',
        crowdBuildingNewsNotificationsSubtitle:
          'Blijf op de hoogte van nieuwe initiatieven, kansen, evenementen\nen het laatste nieuws over samen bouwen en wonen.',
        notificationFrequencyOptions: notificationFrequencyTranslation,
        profileSettingsTitle: 'Account-instellingen',
      },
      followed: {
        title: "Pagina's die ik volg",
        tabs: {
          following: 'Volgen',
          interestList: 'Interesselijst',
        },
        initiatives: 'Initiatieven',
        regions: "Regio's",
        housingForms: 'Woonvormen',
        plots: 'Locaties',
        unfollow: 'Niet meer volgen',
        municipality: 'Gemeente',
        province: 'Provincie',
        youFollowNoInitiatives: 'Je volgt nog geen initiatieven',
        youFollowNoRegions: "Je volgt nog geen regio's",
        youFollowNoHousingForms: 'Je volgt nog geen woonvormen',
        youFollowNoPlots: 'Je volgt nog geen locaties',
        discoverInitiatives: 'Ontdek initiatieven',
        discoverRegions: "Ontdek regio's",
        discoverHousingForms: 'Ontdek woonvormen',
      },
      initiative: {
        sideBar: {
          communityTools: 'Community tools',
          manage: 'Beheren',
          about: 'Overzicht',
          messaging: 'Berichten',
          surveys: 'Vragenlijsten',
          pinBoard: 'Prikbord',
          people: 'Mensen',
          events: 'Evenementen',
        },
        events: {
          noEvents: 'Geen evenementen gekoppeld.',
          pastEvents: 'Afgelopen evenementen',
          draftEvents: 'Concepten',
          upcomingEvents: 'Aankomende evenementen',
          edit: 'Bewerken',
          delete: 'Verwijderen',
          deleteConfirmation:
            'Weet je zeker dat je dit evenement wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
        },
        common: {
          myInitiatives: 'Mijn initiatieven',
          loading: shared.loading,
          unnamedInitiative: 'Naamloos initiatief',
          unknownDevelopmentForm: 'Onbekend',
        },
        home: {
          noInitiativesPlaceholder:
            'Je hebt nog geen initiatieven. Start er vandaag een.',
          startInitiative: 'Start een initiatief',
          membersLabel: 'Deelnemers',
          followersLabel: 'Volgers',
          articlesTitle: 'Handige artikelen',
          unnamedInitiative: 'Naamloos initiatief',
          articlesSubtitle:
            'Weet je niet zeker waar je moet beginnen en of het iets voor jou is? Deze artikelen helpen je op weg.',
          initiativeDraft: 'Concept',
        },
        view: {
          developmentForm: 'Ontwikkelvorm',
          housingForms: shared.housingForms,
          targetGroups: 'Doelgroepen',
          interests: 'Interesses',
          initiativeNameMinLength: 'Moet langer zijn dan 5 tekens',
          nameEmptyLabel: 'Geen naam opgegeven',
          sloganEmptyLabel: 'Geen slogan opgegeven',
          visionEmptyLabel: 'Geen visie opgegeven',
          photosEmptyLabel: 'Nog geen afbeeldingen toegevoegd',
          finishOnboarding: 'Onboarding afronden',
          legalInfoSection: 'Juridisch',
          amenitiesSection: 'Voorzieningen',
          contactDetailsSection: 'Contact',
          pageContentEmpty:
            'Nog geen extra secties. Deze verschijnen op je publieke initiatievenpagina onder je woondroom.',
          deleteButton: 'Verwijder initiatief',
          deleteConfirmDescription:
            'Wanneer je jouw initiatief verwijdert, gaan alle gegevens verloren. Volgers of deelnemers kunnen dit initiatief niet meer vinden.',
          deleteSuccess: 'Initiatief verwijderd',
          confirm: 'Verwijder mijn initiatief',
          cancel: 'Annuleren',
        },
        people: {
          loading: shared.loading,
          people: 'Mensen',
          members: shared.members,
          followers: shared.followers,
          admins: shared.admins,
          requests: 'Verzoeken',
          addedOn: 'Toegelaten op {0}',
          followingSince: 'Volger sinds {0}',
          appliedOn: 'Aangemeld op {0}',
          makeFollower: 'Verplaats naar Volgers',
          makeMember: 'Verplaats naar Deelnemers',
          makeAdmin: 'Maak beheerder',
          removeFromProject: 'Verwijder uit het initiatief',
          participantStatusChanged: 'Status van deelnemer gewijzigd',
        },
        creation: {
          closeModalTitle: 'Sluiten',
          closeModalContent:
            'Weet je zeker dat je wilt sluiten?\nJe wijzigingen worden opgeslagen.',
          createInitiative: 'Initiatief aanmaken',
          statusSelectionTitle: 'Wat is de status van je initiatief?',
          statusAlreadyBuiltTitle: 'Al gebouwd',
          statusAlreadyBuiltDescription:
            'Het initiatief is al gebouwd en we zoeken leden of kennis.',
          statusStillToBuildTitle: 'Nog te bouwen',
          statusStillToBuildDescription:
            'Het initiatief moet nog gebouwd worden.',
          stepLabel: 'Stap {0}',
          back: shared.back,
          next: 'Ga verder',
          publishInitiative: 'Publiceer mijn initiatief',
          done: 'Voltooien',
          closeTheForm: 'Afsluiten',
          initiativePhaseNames: initiativePhaseNameTranslation,
          initiativePhaseDescriptions: initiativePhaseDescriptionTranslation,
          creationStepTitles: initiativeCreationStepTitleTranslation,
          creationStepDescriptions:
            initiativeCreationStepDescriptionTranslation,
          nameLabel: 'Initiatiefnaam',
          namePlaceholder: 'Voorbeeld: Erfdelen in Zwolle',
          sloganLabel: 'Jouw initiatief in één zin',
          sloganPlaceholder:
            'Voorbeeld: Een tiny house aan de rand van Alkmaar',
          livingVisionLabel: 'Deel je woonvisie',
          imagesLabel: 'Afbeeldingen',
          imagesSubtitle: 'Laat zien hoe jij wilt wonen.',
          bannerImageLabel: 'Bannerafbeelding',
          uploadNewBannerImage: 'Nieuwe afbeelding uploaden',
          initiativeDetailsBuyRentQuestion: 'Wordt het huur of koop?',
          initiativeDetailsRentSegmentQuestion: 'Om wat voor huur gaat het?',
          initiativeDetailsBuy: 'Koop',
          initiativeDetailsRent: 'Huur',
          initiativeDetailsMix: 'Mix',
          initiativeDetailsDontKnow: 'Weet ik nog niet',
          initiativeDetailsNumberOfHouseholds: 'Aantal huishoudens',
          initiativeDetailsThemes: 'Themas',
          initiativeDetailsPriceLabel: 'Prijs',
          initiativeDetailsPricePerM2Label: 'Prijs per woning (Schaal)',
          livingTogetherSharedSpacesQuestion: 'Wat voor ruimtes wil je delen?',
          livingTogetherShareCommonSpacesQuestion:
            'Wil je gemeenschappelijke ruimtes delen?',
          locationAlreadyHavePlot: 'Heb je al een kavel of locatie?',
          locationPostcode: 'Postcode',
          locationPostcodePlaceholder: '1884 ZZ',
          locationStreet: 'Straat',
          locationStreetPlaceholder: 'Dorpsstraat 12',
          locationPermitQuestion: 'Zijn alle bouwvergunningen rond?',
          locationBuildAndLiveHeading: 'Waar wil je bouwen en wonen?',
          locationLocality: 'Woonplaats',
          imagesInfoAlert:
            'Gebruik .jpg, .jpeg, .png of .webp bestanden van maximaal 500KB',
          visionSummaryLabel: 'Jouw visie',
          visionSummaryPlaceholder:
            'Wat wil je bouwen, en met wie? Houd het bij 2 à 3 zinnen - dit is het eerste wat mensen van je lezen.',
          livingVisionTextBlockTitlePlaceholder: 'Voorbeeld: Visie',
          developmentForm: 'Ontwikkelvorm',
          targetGroups: 'Doelgroepen',
          housingForms: shared.housingForms,
          interests: 'Interesses',
          selectOne: 'Selecteer één optie',
          selectOneOrMore: 'Selecteer één of meer',
          areYouLookingForMembers: 'Ben je op zoek naar leden?',
          lookingForMembersTitle: 'Met wie wil je wonen? ',
          lookingForMembersSubtitle:
            'Geef een korte samenvatting wie je zoekt. Dit komt bovenaan je pagina te staan.',
          lookingForMembersPlaceholder:
            'Bijv. een generatiemix, mensen met bepaalde waarden, etc. ',
          numberOfHomes: 'Aantal woningen',
          projectSize: 'Vierkante meters (BVO)',
          purchaseBudget: shared.purchaseBudget,
          rentalBudget: shared.rentalBudget,
          numberOfHomesOptions: humberOfHomesTranslation,
          ownershipModeOptions: ownershipModeTranslation,
          rentSegmentOptions: rentSegmentTranslation,
          plotUnderOption: 'Kavel in optie?',
          notUnderOptionButInMind: 'Nee, maar wel op het oog',
          address: 'Adres',
          permit: 'Bouwvergunning',
          financingRequirementsConstruction: 'Financieringsbehoefte bouw',
          financingRequirementsPlanning: 'Financieringsbehoefte plankosten',
          kvkRegistration: 'Ingeschreven bij KVK',
          contactPersonFirstName: 'Voornaam contactpersoon',
          contactPersonLastName: 'Achternaam contactpersoon',
          contactPersonEmailAdress: 'E-mailadres contactpersoon',
          contactPersonPhoneNumber: 'Telefoonnummer contactpersoon',
          contactPhonePlaceholder: '0000000000',
          customAmenities: 'Eigen voorzieningen',
          addCustomAmenity: 'Eigen voorziening toevoegen',
          amenityNamePlaceholder: 'Naam voorziening',
          addOther: 'Anders, namelijk',
          save: 'Opslaan',
          cancel: shared.cancel,
          customAmenityAdded: 'Voorziening toegevoegd',
          initiativeOnlineTitle: 'Je initiatief is online!',
          initiativeOnlineDescription:
            'Gefeliciteerd! Je initiatief is nu zichtbaar op CrowdBuilding. Zet een volgende stap om je woondroom werkelijkheid te maken.',
          eLearningCardTitle: 'Leer over collectief bouwen en wonen',
          eLearningCardDescription:
            'Bekijk onze e-learnings over collectief bouwen en wonen.',
          eLearningCardLinkLabel: 'Ga naar e-learning',
          knowledgeHubCardTitle: 'Ga naar kennishub',
          knowledgeHubCardDescription:
            'Lees meer in onze kennishub over collectief bouwen en wonen.',
          knowledgeHubCardLinkLabel: 'Ga naar kennishub',
          meetingCardTitle: 'Plan een meeting',
          meetingCardDescription:
            'We horen graag meer over jouw initiatief en hoe we je verder kunnen helpen. Plan een afspraak.',
          meetingCardLinkLabel: 'Plan een afspraak',
          pageContentTitle: 'Vertel je woonidee',
          pageContentSubtitle:
            'Een goed verhaal trekt de juiste mensen aan. Je kunt de tekst altijd nog in je dashboard aanpassen.',
          pageContentPlaceholders: {
            mainBlock: {
              title: 'Bijvoorbeeld: Wie zijn wij',
              body: 'Wie zijn jullie, en wat maakt dit initiatief bijzonder? Denk aan: jullie waarden, de regio en wat jullie drijft. Houd het bij 3 à 4 zinnen.\nJe past de opmaak en volgorde aan met de werkbalk hieronder.',
            },
            visionBlock: {
              title: 'Bijvoorbeeld: Onze visie',
              body: 'Hoe willen jullie wonen? Denk aan: het aantal woningen, type woningen en of je huurt of koopt. Houd het bij 3 à 4 zinnen.',
            },
            detailsBlock: {
              title: 'Bijvoorbeeld: Locatie en planning',
              body: 'Waar willen jullie bouwen, en wanneer? Denk aan: de regio, de fase waarin jullie zitten en wat jullie nog zoeken. Houd het bij 3 à 4 zinnen.',
            },
          },
        },
      },
    },
    plotRegistry: {
      welcome: {
        title: 'Welkom bij de Kaartenbak',
        description:
          'Here is some text on what the kaartenbak is, and what advantages you have.',
        selectMunicipality: 'Kies je gemeente/gebied',
        municipality: 'Gemeente',
      },
      regionInfo: {
        stepsTitle:
          'Zorg dat je de volgende stappen hebt voltooid voor je het inschrijvingsproces start.',
        downloadDocument: 'Download document',
      },
      selectInitiative: {
        stepLabel: 'Stap 1 van 3',
        title:
          'Selecteer het initiatief dat je wilt inschrijven voor de kaartenbak',
        subtitle: 'Je dient ingelogd te zijn om een initiatief te selecteren.',
        noInitiativesTitle: 'Geen initiatieven gevonden',
        noInitiativesDescription:
          'Je bent geen eigenaar of beheerder van een initiatief. Maak eerst een initiatief aan of vraag toegang als beheerder.',
      },
      uploadDocuments: {
        stepLabel: 'Stap 2 van 3',
        title: 'Upload de vereiste documenten',
        description:
          'Deze documenten worden gedeeld met de gemeente {municipalityName}. Zij bepalen de uiteindelijke goedkeuring voor de kaartenbak.',
        warningBold: 'Let op:',
        warningText:
          'Na het indienen van deze documenten is het niet meer mogelijk om wijzigingen aan te brengen.',
        uploadButton: 'Upload hier',
        consent:
          'Ik ga er mee akkoord dat mijn gegevens worden gedeeld met de gemeente {municipalityName}.',
        uploadSuccess: 'Document geüpload',
        deleteSuccess: 'Document verwijderd',
      },
      confirmation: {
        congratulations: 'Gefeliciteerd!',
        title: 'De documenten zijn ingediend!',
        subtitle: 'Je ontvangt een bevestiging van de indiening via e-mail.',
        step1Title: 'Interview met gemeente',
        step1Description:
          'De gemeente nodigt jullie initiatief op korte termijn uit voor een interview.',
        step2Title: 'Correctie en aanvulling',
        step2Description:
          'Eventueel vraagt de gemeente om onvolledigheden te corrigeren of aan te vullen.',
        step3Title: 'Besluit gemeente',
        step3Description:
          'De gemeente {municipalityName} beoordeelt of jullie initiatief wordt toegelaten tot de kaartenbak.',
        step4Title: 'Toelating kaartenbak',
        step4Description:
          'Bij goedkeuring staat jullie initiatief officieel in de kaartenbak van de gemeente {municipalityName} en kunnen jullie inschrijven op bouwkavels.',
      },
    },
    error: {
      notFoundTitle: 'Oeps! Deze pagina is niet gevonden.',
      notFoundMessage:
        'Misschien een typefoutje in de adresbalk? Ga terug naar onze homepage of gebruik het menu.',
      imageAlt: 'Pagina niet gevonden',
    },
    form: {
      validation: {
        required: 'Dit veld is verplicht',
        minLength: 'Moet minimaal {0} tekens bevatten',
        maxLength: 'Mag maximaal {0} tekens bevatten',
        min: 'Moet minimaal {0} zijn',
        max: 'Mag maximaal {0} zijn',
        invalidEmail: 'Voer een geldig e-mailadres in',
        invalidUrl: 'Voer een geldige URL in',
        invalidFormat: 'Ongeldig formaat',
        mustBeNumber: 'Moet een getal zijn',
        mustBeInteger: 'Moet een heel getal zijn',
      },
      submissionResponse: {
        success: 'Formulier succesvol verzonden',
        fail: 'Formulierverzending mislukt',
      },
    },
    steunpuntAmsterdam: {
      hero: {
        title: 'Samen wonen begint hier',
        subtitle:
          'Een woongroep vinden, zelf starten, of gewoon meer weten — wij helpen je op weg.',
        locationTag: 'Amsterdam',
        categoryTag: 'Woongroepen 55+',
      },
      landing: {
        aboutUs: {
          title: 'Over ons',
          text: 'Het Steunpunt Collectief Wonen Amsterdam is een initiatief van !WOON, in samenwerking met Woonsaem, OWA 50+ en de gemeente Amsterdam. We informeren Amsterdammers over de verschillende vormen van collectief wonen, ondersteunen nieuwe initiatieven bij hun eerste stappen en brengen woningzoekenden en bestaande wooninitiatieven samen. We helpen je online én offline. Kom langs bij ons spreekuur voor persoonlijk advies, of sluit aan bij een van onze evenementen.',
        },
        agenda: {
          title: 'Agenda',
        },
        whyCollectiveLiving: {
          title: 'Waarom collectief wonen?',
          cards: {
            independentAtHome: {
              title: 'Langer zelfstandig thuis',
              text: 'Samen wonen maakt het makkelijker om voor jezelf te blijven zorgen. Met buren die helpen waar nodig, op jouw voorwaarden.',
            },
            livingTogether: {
              title: 'Samen wonen, samen leven',
              text: 'Ontdek hoe collectief wonen je een fijner, socialer en betaalbaarder thuis kan geven.',
            },
            homeFit: {
              title: 'Een huis dat bij je past',
              text: 'Je leven verandert, je woonwensen ook. Collectief wonen geeft je de ruimte om mee te denken over hoe jouw huis eruitziet.',
            },
            neverAlone: {
              title: 'Nooit meer alleen aan tafel',
              text: 'Collectief wonen betekent buren die naar je omkijken. Een kopje koffie, een praatje in de tuin — gewoon omdat het kan.',
            },
          },
        },
        lookingForHousing: {
          title: 'Ik zoek een woning in Amsterdam',
          text: 'Het Steunpunt Collectief Wonen gaat over een paar weken open. Schrijf je nu vast in en blijf op de hoogte.',
        },
        whySteunpunt: {
          title: 'Waarom Steunpunt Collectief Wonen?',
          text: 'Het Steunpunt bestaat omdat samen wonen voor veel mensen nieuw is. Wij leggen uit hoe het werkt en helpen je op weg. Of je nu een woongroep zoekt of er zelf een wilt starten.',
        },
        forWhom: {
          title: 'Voor wie is het Steunpunt bedoeld?',
          text: 'Voor Amsterdammers die openstaan voor een andere manier van wonen. Of je nu meer verbinding zoekt, te groot woont, of nadenkt over hoe je later wilt wonen - wij helpen je verder.',
        },
        residentStories: {
          title: 'Verhalen van bewoners',
        },
        registerGroup: {
          title: 'Ik wil mijn woongroep inschrijven',
          text: 'Laat andere Amsterdammers je woongroep ontdekken',
        },
        questions: {
          title: 'Vragen?',
          text: 'Freddie en Mirjam staan je graag te woord',
          buttonLabel: 'Maak een afspraak',
        },
      },
      nav: {
        about: 'Over Steunpunt',
        knowledgeHub: 'Kennishub',
        agenda: 'Agenda',
        contact: 'Contact',
      },
      ourPartners: {
        title: 'Onze partners',
      },
      footer: {
        description:
          'Van eerste idee tot sleuteloverdracht. Wij helpen Amsterdammers die samen willen wonen.',
        contactHeader: 'CONTACT',
        platformHeader: 'PLATFORM',
        dataVia: 'Data via',
      },
      signup: {
        triggerLabel: 'Meld je aan',
        modalTitle: 'Meld je aan',
        signupTypeLabel:
          'Kies eerst of je je aanmeldt als individu of als groep',
        tabIndividual: 'Individueel',
        tabGroup: 'Groep',
      },
      signupIndividual: {
        triggerLabel: 'Meld je aan',
        modalTitle: 'Meld je aan',
        firstNameLabel: 'Voornaam',
        firstNamePlaceholder: 'Je voornaam',
        lastNameLabel: 'Achternaam',
        lastNamePlaceholder: 'Je achternaam',
        middlePartLabel: 'Tussenvoegsel',
        middlePartPlaceholder: 'bijv. van der',
        emailLabel: 'E-mailadres',
        emailPlaceholder: 'naam@voorbeeld.nl',
        ageCategoryLabel: 'Leeftijdscategorie',
        ageCategoryLoadingLabel: 'Leeftijdscategorieen laden...',
        ageCategoryPlaceholder: 'Kies een leeftijdscategorie',
        locationLabel: 'Waar in Amsterdam zou je graag willen wonen?',
        termsLabel: `Steunpunt Collectief Wonen Amsterdam draait op het CrowdBuilding-platform. Door je aan te melden ga je akkoord met de [privacyverklaring](https://crowdbuilding.com${pages.legal}) van CrowdBuilding B.V.`,
        successTitle: 'Bedankt voor je aanmelding',
        successText:
          'We laten je weten wanneer het Steunpunt Collectief Wonen opent.',
        successToast: 'Je aanmelding is verstuurd.',
        errorToast: 'Je aanmelding kon niet worden verstuurd.',
        validation: {
          firstNameRequired: 'Vul je voornaam in',
          lastNameRequired: 'Vul je achternaam in',
          emailInvalid: 'Vul een geldig e-mailadres in',
          ageCategoryRequired: 'Kies een leeftijdscategorie',
          locationRequired: 'Vul je woonplaats in',
          termsRequired: 'Je moet akkoord gaan met de voorwaarden',
        },
      },
      signupGroup: {
        triggerLabel: 'Schrijf je woongroep in',
        modalTitle: 'Meld je aan',
        firstNameLabel: 'Voornaam',
        firstNamePlaceholder: 'Je voornaam',
        lastNameLabel: 'Achternaam',
        lastNamePlaceholder: 'Je achternaam',
        middlePartLabel: 'Tussenvoegsel',
        middlePartPlaceholder: 'bijv. van der',
        emailLabel: 'E-mailadres',
        emailPlaceholder: 'naam@voorbeeld.nl',
        groupNameLabel: 'Naam van je groep',
        groupNamePlaceholder: 'Vul de naam van je groep in',
        locationLabel: 'Waar in Amsterdam bevindt jullie groep zich?',
        commentsLabel: 'Andere opmerkingen',
        termsLabel: `Steunpunt Collectief Wonen Amsterdam draait op het CrowdBuilding-platform. Door je aan te melden ga je akkoord met de [privacyverklaring](https://crowdbuilding.com${pages.legal}) van CrowdBuilding B.V.`,
        successTitle: 'Bedankt voor je aanmelding',
        successText:
          'We laten je weten wanneer het Steunpunt Collectief Wonen opent.',
        successToast: 'Je aanmelding is verstuurd.',
        errorToast: 'Je aanmelding kon niet worden verstuurd.',
        validation: {
          firstNameRequired: 'Vul je voornaam in',
          lastNameRequired: 'Vul je achternaam in',
          emailInvalid: 'Vul een geldig e-mailadres in',
          groupNameRequired: 'Vul de naam van je groep in',
          locationRequired: 'Vul je woonplaats in',
          termsRequired: 'Je moet akkoord gaan met de voorwaarden',
        },
      },
    },
  },
  cass: {
    layout: {
      headerSubtitle: 'Crowdbuilding Admin & supportservices',
    },
    analytics: {
      pageTitle: 'Gebruikersanalyse',
      pageDescription:
        'Gebruikersactiviteitsstatistieken op basis van login-, bezoek- en aanmeldgegevens.',
      loading: 'Analyse laden...',
      timeframe: 'Tijdsperiode',
      exportCsv: 'Exporteer CSV',
      exportCsvSuccess: 'Gebruikersdata-export gestart',
      exportCsvError: 'Exporteren van gebruikersdata mislukt',
      timeframes: {
        today: 'Vandaag',
        yesterday: 'Gisteren',
        last7days: 'Afgelopen 7 dagen',
        weekToDate: 'Week tot nu toe',
        last30days: 'Afgelopen 30 dagen',
        thisMonth: 'Deze maand',
        lastMonth: 'Vorige maand',
        last90days: 'Afgelopen 90 dagen',
        quarterToDate: 'Kwartaal tot nu toe',
        thisYear: 'Dit jaar (jan - vandaag)',
        lastCalendarYear: 'Vorig kalenderjaar',
      },
      kpi: {
        totalUsers: 'Totaal gebruikers',
        mau: 'Maandelijks actieve gebruikers',
        mauSubtitle: 'Actief deze maand',
        dau: 'Dagelijks actieve gebruikers',
        dauSubtitle: 'Actief vandaag',
        inactive: 'Inactieve gebruikers',
        percentActive: '% actief',
      },
      charts: {
        mauTitle: 'Maandelijks actieve gebruikers',
        mauSubtitle:
          'Nieuwe aanmeldingen en terugkerende actieve gebruikers per maand',
        dauTitle: 'Dagelijks actieve gebruikers',
        dauSubtitle:
          'Gebruikers laatst actief per dag in geselecteerde periode',
        newSignups: 'Nieuwe aanmeldingen',
        returningActive: 'Terugkerend actief',
        activeUsers: 'Actieve gebruikers',
        mauTooltip:
          'Gestapelde vlakdiagram van maandelijks actieve gebruikers, opgesplitst in nieuwe aanmeldingen (geregistreerd in die maand) en terugkerende actieve gebruikers (geregistreerd in een eerdere maand). Activiteit is gebaseerd op laatste login- of bezoekdatum.',
        dauTooltip:
          'Staafdiagram van dagelijks actieve gebruikers. Elke staaf toont gebruikers waarvan de laatste login- of bezoekdatum op die specifieke dag valt binnen de geselecteerde periode.',
        signupsTitle: 'Dagelijkse aanmeldingen',
        signupsSubtitle:
          'Nieuwe gebruikersregistraties per dag in geselecteerde periode',
        signupsLabel: 'Aanmeldingen',
        signupsTooltip:
          'Staafdiagram van dagelijkse gebruikersaanmeldingen. Elke staaf toont gebruikers waarvan de aanmaakdatum op die specifieke dag valt binnen de geselecteerde periode.',
        signupSourcesTitle: 'Aanmeldbronnen',
        signupSourcesSubtitle:
          'Top aanmeldkanalen voor nieuwe registraties in geselecteerde periode',
        signupSourcesTooltip:
          'Horizontaal staafdiagram van de top 10 aanmeldbronnen (utm_source of equivalent) voor gebruikers die zich hebben geregistreerd binnen de geselecteerde periode. Lege of ontbrekende bronnen worden gegroepeerd als onbekend.',
        signupSourceUnknown: 'Onbekend / direct',
        signupSourceLabel: 'Bron',
        signupSourceCount: 'Aanmeldingen',
      },
    },
    initiativeAnalytics: {
      sectionTitle: 'Initiatievenanalyse',
      sectionDescription:
        'Populariteit, beheerdersactiviteit en berichtenstatistieken voor initiatieven.',
      loading: 'Initiatievenanalyse laden...',
      timeframe: 'Tijdsperiode',
      exportCsv: 'Exporteer initiatieven CSV',
      exportCsvSuccess: 'Initiatievendata-export gestart',
      exportCsvError: 'Exporteren van initiatievendata mislukt',
      timeframes: {
        today: 'Vandaag',
        yesterday: 'Gisteren',
        last7days: 'Afgelopen 7 dagen',
        weekToDate: 'Week tot nu toe',
        last30days: 'Afgelopen 30 dagen',
        thisMonth: 'Deze maand',
        lastMonth: 'Vorige maand',
        last90days: 'Afgelopen 90 dagen',
        quarterToDate: 'Kwartaal tot nu toe',
        thisYear: 'Dit jaar (jan - vandaag)',
        lastCalendarYear: 'Vorig kalenderjaar',
      },
      kpi: {
        totalInitiatives: 'Totaal initiatieven',
        mai: 'Maandelijks actieve initiatieven',
        maiSubtitle: 'Beheerdersactiviteit deze maand',
        newFollowers: 'Nieuwe volgers',
        newFollowersSubtitle: 'In geselecteerde periode',
        newMembers: 'Nieuwe leden',
        newMembersSubtitle: 'In geselecteerde periode',
        pendingMembers: 'Openstaande aanvragen',
        pendingMembersSubtitle: 'Nieuwe aanvragen in geselecteerde periode',
        avgAdminResponse: 'Gem. beheerdersreactie',
        avgAdminResponseSubtitle: 'Tijd tot antwoord op berichten',
        avgAdminResponseUnit: 'min',
        totalMessages: 'Verzonden berichten',
        totalMessagesSubtitle: 'In geselecteerde periode',
        replyRate: 'Antwoordpercentage',
        replyRateSubtitle: 'Kanalen met wederzijds gesprek',
        replyRateUnit: '%',
      },
      charts: {
        paceTitle: 'Volgers- en ledenstempo',
        paceSubtitle: 'Nieuwe volgers en leden per maand',
        newFollowers: 'Nieuwe volgers',
        newMembers: 'Nieuwe leden',
        maiTitle: 'Maandelijks actieve initiatieven',
        maiSubtitle: 'Initiatieven met beheerderactiviteit per maand',
        activeInitiatives: 'Actieve initiatieven',
        followersTitle: 'Nieuwe volgers',
        followersSubtitle: 'Nieuwe volgers toegevoegd per maand',
        membersTitle: 'Nieuwe leden',
        membersSubtitle: 'Nieuwe leden toegevoegd per maand',
        adminResponseTitle: 'Beheerdersreactietijd',
        adminResponseSubtitle:
          'Gemiddelde beheerdersreactietijd per maand (minuten)',
        avgAdminResponseMinutes: 'Gem. reactie (min)',
        maiTooltip:
          'Vlakdiagram van maandelijks actieve initiatieven. Een initiatief is actief als een van de beheerders in die maand is ingelogd of het platform heeft bezocht, nadat ze beheerder werden.',
        followersTooltip:
          'Vlakdiagram van nieuwe volgers per maand. Een gebruiker telt mee wanneer hun volger-sinds-datum binnen die maand valt over alle initiatieven.',
        membersTooltip:
          'Vlakdiagram van nieuwe leden per maand. Een gebruiker telt mee wanneer hun lid-sinds-datum binnen die maand valt over alle initiatieven.',
        adminResponseTooltip:
          'Staafdiagram van gemiddelde beheerdersreactietijd in minuten per maand. Berekend als de gemiddelde tijd van een niet-beheerdersbericht tot het eerste beheerdersantwoord, over alle initiatiefkanalen.',
        pendingTitle: 'Openstaande aanvragen',
        pendingSubtitle:
          'Nieuwe lidmaatschapsaanvragen in afwachting per maand',
        pendingTooltip:
          'Vlakdiagram van nieuwe lidmaatschapsaanvragen per maand. Telt gebruikers met aanvragerrol waarvan de aanvraagdatum binnen die maand valt.',
        pendingMembers: 'Openstaande aanvragen',
        messagesTitle: 'Verzonden berichten',
        messagesSubtitle: 'Totaal berichtenboxberichten per maand',
        messagesTooltip:
          'Staafdiagram van totaal verzonden berichten over alle initiatiefkanalen per maand binnen de geselecteerde periode.',
        messagesLabel: 'Berichten',
      },
    },
    threadAnalytics: {
      sectionTitle: 'Discussieanalyse',
      sectionDescription:
        'Discussieactiviteit, betrokkenheid en categorieverdeling voor berichten.',
      loading: 'Discussieanalyse laden...',
      timeframe: 'Tijdsperiode',
      timeframes: {
        today: 'Vandaag',
        yesterday: 'Gisteren',
        last7days: 'Afgelopen 7 dagen',
        weekToDate: 'Week tot nu toe',
        last30days: 'Afgelopen 30 dagen',
        thisMonth: 'Deze maand',
        lastMonth: 'Vorige maand',
        last90days: 'Afgelopen 90 dagen',
        quarterToDate: 'Kwartaal tot nu toe',
        thisYear: 'Dit jaar (jan - vandaag)',
        lastCalendarYear: 'Vorig kalenderjaar',
      },
      kpi: {
        totalPosts: 'Totaal berichten',
        totalPostsSubtitle: 'Hoofdberichten in geselecteerde periode',
        totalReplies: 'Totaal reacties',
        totalRepliesSubtitle: 'Reactieberichten in geselecteerde periode',
        replyRate: 'Reactiepercentage',
        replyRateSubtitle: 'Hoofdberichten met minstens één reactie',
        replyRateUnit: '%',
        totalLikes: 'Totaal likes',
        totalLikesSubtitle: 'Likes op berichten in geselecteerde periode',
        uniqueAuthors: 'Unieke auteurs',
        uniqueAuthorsSubtitle: 'Verschillende auteurs in geselecteerde periode',
        postsWithMedia: 'Berichten met media',
        postsWithMediaSubtitle:
          'Berichten met bijlagen in geselecteerde periode',
      },
      charts: {
        postsTitle: 'Nieuwe berichten',
        postsSubtitle: 'Hoofdberichten aangemaakt per maand',
        newPosts: 'Nieuwe berichten',
        postsTooltip:
          'Vlakdiagram van nieuwe hoofddiscussieberichten per maand. Verborgen berichten en reacties zijn uitgesloten.',
        repliesTitle: 'Nieuwe reacties',
        repliesSubtitle: 'Reactieberichten aangemaakt per maand',
        newReplies: 'Nieuwe reacties',
        repliesTooltip:
          'Vlakdiagram van reactieberichten per maand. Een reactie is elk bericht met een bovenliggend bericht.',
        likesTitle: 'Likes in de tijd',
        likesSubtitle: 'Totaal likes op berichten aangemaakt per maand',
        likesLabel: 'Likes',
        likesTooltip:
          'Staafdiagram van totaal likes op berichten die elke maand zijn aangemaakt. Telt kijkerreacties met een like per bericht.',
        authorsTitle: 'Actieve auteurs',
        authorsSubtitle: 'Unieke auteurs die posten per maand',
        activeAuthors: 'Actieve auteurs',
        authorsTooltip:
          'Vlakdiagram van verschillende auteurs die zichtbare berichten hebben aangemaakt per maand binnen de geselecteerde periode.',
        categoriesTitle: 'Topcategorieën',
        categoriesSubtitle:
          'Meest gebruikte berichtcategorieën in geselecteerde periode',
        categoriesTooltip:
          'Horizontaal staafdiagram van de top berichtcategorieën op hoofdberichten. Berichten zonder categorie worden gegroepeerd als onbekend.',
        categoryLabel: 'Categorie',
        categoryCount: 'Berichten',
        categoryUnknown: 'Zonder categorie',
      },
    },
    sidebar: {
      brand: 'CASS',
      beta: 'BETA',
      logoAlt: 'CrowdBuilding',
      logout: 'Uitloggen',
      language: 'Taal',
      languageEn: 'Engels',
      languageNl: 'Nederlands',
      nav: {
        start: {
          label: 'Start',
          dashboard: 'Dashboard',
          analytics: 'Analyse',
        },
        tools: {
          label: 'Tools',
          builder: 'Querybuilder',
        },
        home: {
          label: 'Start',
          initiatives: 'Initiatieven',
          plots: 'Locaties',
          topicCommunities: 'Topicgemeenschappen',
          serviceProviders: 'Experts',
          serviceProvidersConcepts: 'Experts (concepten)',
          users: 'Gebruikers',
          regions: 'Provincies',
          municipalities: 'Gemeenten',
          localities: 'Plaatsen',
          spotlight: 'Uitgelicht',
          threads: 'Discussies',
          postCategories: 'Berichtcategorieën',
          businessProfiles: 'Bedrijfsprofielen',
        },
        content: {
          label: 'Content',
          blogs: 'Blogs',
          news: 'Nieuws',
          stories: 'Verhalen',
          events: 'Evenementen',
          landingMarketingStats: 'Landingspagina marketingstatistieken',
          knowledgeHub: 'Kennishub',
          housingForms: 'Woonvormen',
          pageSeo: 'Pagina SEO',
        },
        processes: {
          label: 'Processen',
          plotRegistry: 'Kaartenbak',
        },
        settings: {
          label: 'Instellingen',
          ageCategories: 'Leeftijdscategorieën',
          amenities: 'Voorzieningen',
          buildingTypes: 'Bouwtypen',
          businessProfileTypes: 'Bedrijfsprofieltypen',
          buyBudgets: 'Koopbudgetten',
          rentBudgets: 'Huurbudgetten',
          developmentForms: 'Ontwikkelingsvormen',
          houseSurfaces: 'Woonoppervlakten',
          housingFormTypes: 'Woonvormtypen',
          interests: 'Interesses',
          involvement: 'Betrokkenheid',
          livingEnvironments: 'Leefomgevingen',
          offerTypes: 'Aanbodtypen',
          ownershipSituations: 'Eigendomssituaties',
          phases: 'Fasen',
          serviceProviderSpecializations: 'Dienstverlenerspecialisaties',
          targetAudiences: 'Doelgroepen',
          platformTenants: 'Platformtenants',
        },
        cassUserManagement: {
          label: 'CASS-gebruikersbeheer',
          adminUsers: 'Beheerders',
        },
      },
    },
  },
} as const
